import React, { Component } from 'react';
import { connect } from 'react-redux'
import * as Actions from './redux-actions.js'
import request from 'request'
import { DisappearedLoading } from 'react-loadingg';
import { withRouter } from "react-router-dom";


//import { Link, Route } from 'react-router-dom'
import * as globals from './globals.js'
import * as helpers from './helpers.js'

import './ModernHome.css'





class RegionsPage extends Component {
   constructor(props) {
    super(props);
    window.scrollTo(0, 0);

    this.handleClick = this.handleClick.bind(this)


  }

  
  handleClick(event) {
    this.props.clearBooking()
    this.props.clearBookingInfo()
    this.props.createBooking(-1, 3)
    this.props.bookingStepStart(1)
    this.props.history.push('/atform')
  }



  render() {
  
   if (! this.props.reduxDictionary) {
      return (<div style={{paddingBottom:"5rem"}} class="has-background-dark"><DisappearedLoading/></div>)
   }

   let content


 return ( 
       
<div className="modern-home" style={{marginBottom:"5rem"}}>

{/* Hero Section */}
<section className="hero is-fullheight-with-navbar modern-hero-regions">
  <div className="hero-body">
    <div className="container">
      <div className="columns is-vcentered">
        <div className="column is-6">
          <div className="hero-content">
            <h1 className="modern-title">
              Discover <span className="highlight">Azerbaijan's</span> Beautiful Regions
            </h1>
            <p className="modern-subtitle">
              From ancient cities to stunning mountain landscapes, explore the diverse beauty of Azerbaijan with our reliable transfer services
            </p>
            <div className="hero-buttons">
              <button 
                className="button is-primary is-large modern-btn"
                onClick={this.handleClick}
              >
                <span className="icon"><i className="fas fa-map-marked-alt"></i></span>
                <span>Book Regional Transfer</span>
              </button>
            </div>
          </div>
        </div>
        
        <div className="column is-6">
          <div className="hero-image-container">
            <div className="floating-card">
              <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/road.jpg" alt="Azerbaijan Regions" className="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Main Content Section */}
<section className="section modern-regions-content">
  <div className="container">
    <div className="columns is-centered">
      <div className="column is-10">
        
        <div className="region-intro">
          <h2 className="section-title" dangerouslySetInnerHTML={{__html: helpers.cnt('region_page_1')}}></h2>
          <div className="region-description" dangerouslySetInnerHTML={{__html: helpers.cnt('region_page_2')}}></div>
        </div>

        <div className="region-highlights">
          <div className="highlight-card">
            <div className="highlight-icon">
              <i className="fas fa-mountain"></i>
            </div>
            <div className="highlight-content" dangerouslySetInnerHTML={{__html: helpers.cnt('region_page_3')}}></div>
          </div>
          
          <div className="highlight-card">
            <div className="highlight-icon">
              <i className="fas fa-landmark"></i>
            </div>
            <div className="highlight-content" dangerouslySetInnerHTML={{__html: helpers.cnt('region_page_4')}}></div>
          </div>
        </div>

        <div className="centered" style={{marginTop:"3rem"}}>
          <button 
            className="button is-primary is-large modern-cta-btn" 
            onClick={this.handleClick}
          >
            <span className="icon"><i className="fas fa-calendar-check"></i></span>
            <span>Book Your Regional Transfer</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</section>

{/* Features Section */}
<section className="section modern-features">
  <div className="container">
    <div className="has-text-centered regions-features-header">
      <h2 className="section-title">Why Travel with Az-Tur?</h2>
      <p className="section-subtitle">Your trusted partner for regional exploration</p>
    </div>
    
    <div className="columns is-multiline">
      <div className="column is-3">
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-route"></i>
          </div>
          <h3 className="feature-title">All Regions</h3>
          <p className="feature-description">
            We cover all major regions and cities across Azerbaijan
          </p>
        </div>
      </div>
      
      <div className="column is-3">
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-user-tie"></i>
          </div>
          <h3 className="feature-title">Local Drivers</h3>
          <p className="feature-description">
            Experienced drivers who know the best routes and hidden gems
          </p>
        </div>
      </div>
      
      <div className="column is-3">
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h3 className="feature-title">Safe Travel</h3>
          <p className="feature-description">
            Well-maintained vehicles and professional service
          </p>
        </div>
      </div>
      
      <div className="column is-3">
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-dollar-sign"></i>
          </div>
          <h3 className="feature-title">Fair Prices</h3>
          <p className="feature-description">
            Transparent pricing with no hidden fees
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

</div>

    )

  }
}


const mapStateToProps$RegionsPage = function (state) {
   return { reduxDictionary: state.dictionary,
            serverReachable: state.serverStatus }
}

const mapDispatchToProps$RegionsPage = function(dispatch) {
  return {
    createBooking: function(carTypeId, transferType) { dispatch(Actions.actionCreateBooking({car_type: carTypeId, transfer_type: transferType})) },
    bookingStepStart: function(step) { dispatch(Actions.actionBookingStepStart(step)) },
    clearBookingInfo: function() { dispatch(Actions.actionClearBookingInfo()) },
    clearBooking: function() { dispatch(Actions.actionClearBooking()) }
  }
}

export default withRouter(connect(mapStateToProps$RegionsPage, mapDispatchToProps$RegionsPage)(RegionsPage))



